import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"
import { NewsBannerNotify } from "@/modules/admin/news/components/news-banner-notify"
import { useChatAvailabilityQuery } from "@/modules/chats/services/useChatAvailabilityQuery"
import { useChatThreadContext } from "@/modules/chats/stores/useChatThreadStore"
import { LeadsOnDutyBanner } from "@/modules/leads-on-duty/components/leads-on-duty-banner"

export const ChatsAvailabilityBanner = () => {
  const { t } = useTranslation()
  const { chatAvailability } = useChatAvailabilityQuery()

  const isMedicalChat = useChatThreadContext((state) => state.selectedThread?.isMedicalChat) ?? false

  const inactiveLanguages = useMemo(
    () =>
      chatAvailability
        .filter((item) => item && !(isMedicalChat ? item.canCreateMedicalChats : item.canCreateAdministrativeChats))
        .map((item) => {
          switch (item.language) {
            case "ENGLISH":
              return t("common.languageList.english")
            case "FRENCH":
              return t("common.languageList.french")
            case "ITALIAN":
              return t("common.languageList.italian")
            case "GERMAN":
              return t("common.languageList.german")
          }
        }),
    [chatAvailability, isMedicalChat, t],
  )

  return (
    <div>
      <NewsBannerNotify />
      <LeadsOnDutyBanner />
      {inactiveLanguages.length > 0 ? (
        <div className="bg-background-subdued grid h-10 content-end transition-all duration-200">
          <Banner type="full-width" variant="warning">
            {t("admin.capacity.disabledNewChat.warningTitle")} {inactiveLanguages.join(", ")}
          </Banner>
        </div>
      ) : (
        /* Empty div to avoid breaking layout */
        <div></div>
      )}
    </div>
  )
}
